export default __webpack_public_path__ + "static/media/e-ppt-picturemark-d.2f59c4d2.svg";